import React from "react";
import { Box, IconButton } from "@mui/material";

export interface MenuButtonProps {
  menuOpen: boolean;
  onClick?: () => void;
}

const MenuButton = ({ menuOpen, onClick }: MenuButtonProps) => {
  return (
    <IconButton className="flex flex-col" sx={{ alignItems: "end !important" }} onClick={onClick}>
      <Box
        sx={{
          width: menuOpen ? "15px" : "11px",
          height: "2px",
          background: "#333",
          transform: menuOpen ? "rotate(-45deg)" : "",
          marginTop: "6px",
          marginBottom: menuOpen ? "-3px" : "",
          marginRight: menuOpen ? "2px" : "",
          transition: "300ms ease",
          flexShrink: 0
        }}
      />
      <Box
        sx={{
          width: menuOpen ? "29.5px" : "22px",
          height: "2px",
          marginTop: "6px",
          background: "#333",
          transform: menuOpen ? "rotate(45deg)" : "",
          transition: "300ms ease",
          flexShrink: 0
        }}
      />
      <Box
        sx={{
          alignSelf: menuOpen ? "start" : "end",
          width: menuOpen ? "15px" : "11px",
          height: "2px",
          marginTop: menuOpen ? "3px" : "6px",
          marginLeft: menuOpen ? "2px" : "",
          background: "#333",
          transform: menuOpen ? "rotate(-45deg)" : "",
          transition: "300ms ease",
          flexShrink: 0
        }}
      />
    </IconButton>
  );
};

export default MenuButton;